import React from 'react';
import { Link } from 'react-router-dom'
import PageTitle from '../../../shared/javascripts/components/PageTitle/PageTitle'

const Dashboard = (props) => {
  const {match, currentUser} = props;

  return(
    <div className="Dashboard">
      <PageTitle title='Dashboard' /><hr />
      <ul className='nav nav-pills nav-stacked'>
        <li><Link to={`${match.url}/${currentUser.id}/reports`}>Reports</Link></li>
      </ul>
    </div>
  )
}

export default Dashboard


// WEBPACK FOOTER //
// ./src/staff/javascripts/components/Dashboard.jsx